// Hằng số & enum cho service Trình ký online V2.

// Tên bảng = tên endpoint (routing generic của backend).
export const EP = {
  type: "crm_workflow_type",     // loại tờ trình (tái dùng cấu hình V1)
  stepTemplate: "crm_workflow_step", // template bước theo loại (tái dùng)
  request: "tk_request",         // tờ trình
  step: "tk_step",               // bước ký
  message: "tk_message",         // nhật ký / bình luận
  searchTags: "tk_search_tags",  // gợi ý tag @
};

// Route FE — V2 chạy trên URL cũ của V1 (giữ nguyên link/thông báo/bookmark).
export const ROUTE = {
  list: "/workflow_walking",
  add: "/add-workflow_walking",
  edit: (id) => "/edit-workflow_walking/" + id,
  publicView: (hash) => "/ho-so-truc-tuyen/" + hash,
};

// Key phân quyền (giữ nguyên như V1 để không phải cấu hình lại quyền).
export const IDROLE = "workflow_walking";

// Trạng thái tờ trình.
export const STATUS = { RUNNING: 1, APPROVED: 2, CANCELED: 4 };

// Hành động trên một bước ký.
export const ACTION = {
  WAIT: 0,        // chờ ký
  APPROVE: 1,     // ký duyệt
  REQUEST_MORE: 2,// yêu cầu bổ sung
  RETURN: 3,      // trả về
  CANCEL: 4,      // hủy bỏ
  CONSULT: 5,     // xin ý kiến
};

// Nhãn hiển thị cho action (tái dùng ở list + form).
export const ACTION_META = {
  1: { text: "Đã duyệt", cls: "text-success", icon: "fas fa-check-circle" },
  2: { text: "Yêu cầu bổ sung", cls: "text-info", icon: "fas fa-times-circle" },
  3: { text: "Trả về", cls: "text-danger", icon: "fas fa-times-circle" },
  4: { text: "Hủy bỏ", cls: "text-danger", icon: "fas fa-times-circle" },
  5: { text: "Xin ý kiến", cls: "text-secondary", icon: "far fa-question-circle" },
  0: { text: "Chờ ký", cls: "text-warning", icon: "fas fa-clock" },
};

// Gom bước theo position + sắp ký chính trước, ký phụ sau.
export function groupStepsByPosition(steps = []) {
  const grouped = {};
  steps.forEach((step) => {
    const pos = step.position;
    if (!grouped[pos]) {
      grouped[pos] = {
        step_id: step.id,
        position: pos,
        group_name: step.group_name,
        department_name: step.department_name,
        timecheck: step.timecheck,
        member: [],
      };
    }
    grouped[pos].member.push({
      id: step.id,
      user_id: step.user_id,
      fullname: step.fullname,
      step_type: step.step_type,
      action: step.action,
      position: pos,
      group_name: step.group_name,
      department_name: step.department_name,
      note_comment: step.note_comment,
      timecheck: step.timecheck,
    });
  });
  const sorted = Object.values(grouped).sort((a, b) => a.position - b.position);
  sorted.forEach((g) => g.member.sort((a, b) => a.step_type - b.step_type));
  return sorted;
}
